
<template>
    <div v-if="questions && values">
      <form-question v-for="qid in questionIds" :key="qid" class="light-frame"
        :question="questions[qid]"
        :values="values"
        :value="values[qid]"
        :error-message="errorMessages[questions[qid].a.type]"
        @answer-value="valueUpdated(qid, $event)"
      >
      </form-question>
    </div>
  </div>
</template>

<script>
import Question from './Question'

export default {
  components: {
    'form-question': Question
  },

  props: {
    questions: {
      type: Object,
      required: true
    },
    values: {
      type: Object,
      required: true
    },
    errorMessages: {
      type: Object,
      required: true
    }
  },

  data: function () {
    return {
      questionIds: [
        'id_why_no_cb'
      ]
    }
  },

  created: function () {
  },

  methods: {
    hasError: function () {
      return !this.questionIds.every(qid => this.questions[qid].checkCondition(this.values[qid], this.values))
    },

    valueUpdated: function (qid, v) {
      this.values[qid] = v
    }

  }
}
</script>


// WEBPACK FOOTER //
// PaymentWhyForm.vue?c18188d0